import apis from "../../core/apis.js";

class InvoiceResource {
  constructor($resource, Upload) {
    "ngInject";

    this.$resource = $resource;
    this.Upload = Upload;
  }

  getAll(options) {
    return this.$resource(apis.invoice).get(options);
  }

  getCaptainAll(options) {
    return this.$resource(apis.invoice).get(options);
  }

  get(id) {
    return this.$resource(apis.invoice + id).get();
  }

  search(search = "") {
    return this.$resource(apis.invoice).get({ search });
  }

  post(item) {
    return this.$resource(apis.invoice).save(item);
  }

  end(id) {
    return this.$resource(apis.invoice + id + "/end").save();
  }

  finalize(id) {
    return this.$resource(apis.invoice + id + "/finalize").save();
  }

  markPaid(id) {
    return this.$resource(apis.invoice + id + "/mark_as_paid").save();
  }

  addNote(id, item) {
    return this.$resource(apis.invoice + id + "/add_note").save(item);
  }

  update(id, item) {
    return this.$resource(apis.invoice + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  uploadSettlement(id, data) {
    const url = apis.invoice + id + "/upload_settlements";
    const request = this.Upload.upload({ url, data });
    return { $promise: request };
  }
}

export default InvoiceResource;



// WEBPACK FOOTER //
// ./src/resources/invoice/invoice.resource.js